<template>
  <b-modal
    :id="id || `cropper-modal`"
    size="lg"
    @show="showedModal()"
    content-class="rounded-xl"
    scrollable
  >
    <template #modal-title>
      <i class="ri-crop-line font-size-h4 text-primary"></i>
      Crop Gambar
    </template>
    <div class="cropper-wrapper mb-5">
      <!-- crpper -->
      <b-row>
        <b-col cols="12" lg="9">
          <cropper
            v-if="image.src"
            ref="cropperComponent"
            class="cropper rounded-xl animated mb-3"
            :src="image.src"
            :stencil-props="
              option && option.freeRatio
                ? {}
                : {
                    aspectRatio:
                      option && option.aspectRatio ? option.aspectRatio : 1,
                  }
            "
            @change="onChangeCropper"
          />
        </b-col>
        <b-col cols="12" lg="3" class="">
          <b-row>
            <b-col cols="auto" class="mb-5">
              <cropper-preview
                v-if="image.src"
                class="rounded-xl animated border-2 border-dashed mr-3"
                :width="150"
                :height="150"
                :image="result.image"
                :coordinates="result.coordinates"
              />
            </b-col>
            <b-col cols="auto">
              <cropper-preview
                v-if="image.src"
                class="rounded-pill animated border-2 border-dashed"
                :width="150"
                :height="150"
                :image="result.image"
                :coordinates="result.coordinates"
              />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <template #modal-footer>
      <!-- upload button -->
      <b-button
        v-if="image.src"
        variant="light-success"
        class="animated"
        @click="crop"
        :disabled="isUploading"
        block
      >
        <i class="ri-scissors-line"></i>
        Crop Gambar
      </b-button>
    </template>
  </b-modal>
</template>

<script>
// This function is used to detect the actual image type,
function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}

export default {
  name: "FePerpusCropperUpload",

  props: {
    id: {
      type: String,
      required: false,
    },
    directory: {
      type: String,
      default: null,
    },
    file: {
      default: null,
    },
    option: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      image: {
        src: null,
        type: null,
      },
      result: {
        coordinates: null,
        image: null,
      },
      isUploading: false,
      uploadPercentage: 0,
    };
  },

  methods: {
    blobToFile(theBlob, fileName) {
      //A Blob() is almost a File() - it's just missing the two properties below which we will add
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    crop() {
      const { canvas } = this.$refs.cropperComponent.getResult();
      canvas.toBlob((blob) => {
        // Do something with blob: upload to a server, download and etc.
        let cropImage = this.blobToFile(
          blob,
          `CroppedImage.${this.image.type.split("/")[1]}`
        );

        this.$emit("cropped", cropImage);
        setTimeout(() => {
          this.reset();
          this.$bvModal.hide(this.id || `cropper-modal`);
        }, 100);
      }, this.image.type);
    },
    onChangeCropper({ coordinates, image }) {
      this.result = {
        coordinates,
        image,
      };
    },
    reset() {
      this.result = {
        coordinates: null,
        image: null,
      };
      this.image = {
        src: null,
        type: null,
      };
    },
    loadImage(files) {
      // Reference to the DOM input element
      // const { files } = event.target;
      // Ensure that you have a file before attempting to read it
      if (files && files[0]) {
        // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }
        // 2. Create the blob link to the file to optimize performance:
        const blob = URL.createObjectURL(files[0]);

        // 3. The steps below are designated to determine a file mime type to use it during the
        // getting of a cropped image from the canvas. You can replace it them by the following string,
        // but the type will be derived from the extension and it can lead to an incorrect result:
        //
        // this.image = {
        //    src: blob;
        //    type: files[0].type
        // }

        // Create a new FileReader to read this image binary data
        const reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.image" refers to the image of Vue component
          this.image = {
            // Set the image source (it will look like blob:http://example.com/2c5270a5-18b5-406e-a4fb-07427f5e7b94)
            src: blob,
            // Determine the image type to preserve it during the extracting the image from canvas:
            type: getMimeType(e.target.result, files[0].type),
          };
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsArrayBuffer(files[0]);
      }
    },
    showedModal() {
      this.loadImage([this.file]);
    },
  },
  watch: {},

  mounted() {},

  destroyed() {
    // Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  },
};
</script>

<style lang="scss" scoped>
.cropper-wrapper {
  .cropper {
    max-width: 100%;
    max-height: 600px;
    border: 1px dashed #ddd;
    overflow: hidden;
  }

  input {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/base/component/cropper-modal.vue